import { Trans } from '@lingui/react/macro';
import React from 'react';
import UDButton from 'ud-ui/components/button';
import UDText from 'ud-ui/components/text';
import { theme } from 'styles/theme/theme';

interface SubscriptionTopupSuccessProps {
  onDone: () => void;
}

export const SubscriptionTopupSuccess: React.FC<SubscriptionTopupSuccessProps> = ({ onDone }) => {
  return (
    <div className="flex flex-col gap-3">
      <UDText type="headline">
        <Trans>Баланс пополнен</Trans>
      </UDText>
      <UDText type="body-text" color={theme.colors.Gray}>
        <Trans>Средства зачислены на кошелёк. Тариф подключается отдельной кнопкой «Оплатить с баланса».</Trans>
      </UDText>
      <UDButton type="button" variant="primary" onClick={onDone}>
        <Trans>Готово</Trans>
      </UDButton>
    </div>
  );
};
